//Requestacallback.jsx
import React from 'react';
import '../../../CSS/Services/Ecommerce/Requestacallback.css';



function Requestacallback() {
  
  return (
    <div className='messagepage'>
     <div className='Requestacallbackimg'>
       <img src="../Images/Requestacallbackimg.png" alt="Hand Showing Image" className="handimg"  ></img>
     </div>
    
     <div className='messageform'>
     <div className='messageheading'>
      <h1>Request A Callback </h1>
    </div>
       <form
       action="https://formspree.io/f/xdoqwoyg"
       method="POST"
       >
      <label>Name:</label>
      <input type="text" name="user_name" required className='messageformcontent'/>
      <label>Phone:</label>
      <input type="tel" name="user_phone" required className='messageformcontent'/>
      <label>Email:</label>
      <input type="email" name="user_email" required className='messageformcontent'/>
      <label>Message:</label>
      <textarea id="message" name="message" required className='messageformcontent'></textarea>
      <input type="submit" value="Send Message" className='sendbutton' />
      </form>
     </div>
    </div>
  
  );
}

export default Requestacallback;

